import React from "react";
import { useRoute, Link, useLocation, Router } from "wouter";
import useLevel from "../../../hooks/useLevel";
import useHashLocation from "../../../use-hash-location";
import { useTranslation } from "react-i18next";

function GoBackButton() {
  const [currentLevel] = useLevel();
  const [location, setLocation] = useHashLocation();

  const { t } = useTranslation();

  const tartgetLocation = React.useMemo(() => {
    var split = location.split("/");
    var targetLocation = split.slice(0, -1).join("/"); //location.replace(`/${split[split.length - 1]}`, "");
    return targetLocation == "" ? "/" : targetLocation;
  }, [location]);

  return (
    <div
      style={{
        position: "absolute",
        top: "3vw",
        left: "2vw",
        width: "max-content",
        pointerEvents: "auto",
        visibility: currentLevel > 0 && !location.includes("/login") ? "visible" : "hidden",
        opacity: currentLevel > 0 && !location.includes("/login") ? 1 : 0,
        transition: "opacity 0.5s",
      }}
    >
      <div
        style={{
          zIndex: "10",
          color: "#fff",
          cursor: "pointer",
          display: "flex",
          fontWeight: "400",
          textDecoration: "none",
          fontSize: 0.75 + "vw",
          alignItems: "center",
        }}
        onClick={() => setLocation(tartgetLocation)}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={0.75 + "vw"}
          height={0.75 + "vw"}
          viewBox="0 0 24.334 24.334"
          style={{
            backgroundColor: "#66cc99",
            padding: "0.25vw",
          }}
        >
          <path
            id="arrow-left_2_"
            data-name="arrow-left(2)"
            d="M28.494,14.711v3.072H10.059l8.449,8.449-2.181,2.181L4.16,16.247,16.327,4.08l2.181,2.181-8.449,8.449Z"
            transform="translate(-4.16 -4.08)"
            fill={"#000"}
          />
        </svg>

        <span
          style={{
            marginLeft: "1vw",
            textTransform: "uppercase",
          }}
        >
          {t("BUTTON_BACK")}
        </span>
      </div>
    </div>
  );
}

export default GoBackButton;
